import { createCompoundComponent } from '../../utilities'

import { RadioGroup as RadioGroupRoot } from './RadioGroup'
import { Item } from './Item'

export const RadioGroup = createCompoundComponent(RadioGroupRoot, {
  Item,
})
